import { render, staticRenderFns } from "./CopyButton.vue?vue&type=template&id=3339f0c4&scoped=true"
import script from "./CopyButton.vue?vue&type=script&lang=js"
export * from "./CopyButton.vue?vue&type=script&lang=js"
import style0 from "./CopyButton.vue?vue&type=style&index=0&id=3339f0c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3339f0c4",
  null
  
)

export default component.exports